export type * from 'qrcode';
export * from './elements/qr-code.js';

import QRCode from 'qrcode';

export class QRCodeCrate {
  id = 'oss/qr-code/index';
  crate = 'oss/qr-code';
  ns = 'oss';

  /**
   * @return the QRCode library
   */
  get library() {
    return QRCode;
  }
}

export default new QRCodeCrate();
